import { resetPasswordComponent } from './resetPassword.component';

export const resetPasswordStateName = 'app.resetPassword';

export const resetPasswordState = ($stateProvider) => {
  'ngInject';
  $stateProvider.state({
    name: resetPasswordStateName,
    url: '/resetPassword?token?user',
    component: resetPasswordComponent.name,
    resolve: { logout },
  });
};

function logout(userService) {
  'ngInject';
  userService.logout();
}
